/* THE SET ROW'S SCROLL BAR (2026-10-02; one script for both Set pages since 2026-10-14).

   Under a row of city cards that has more than fits: the collection lists' own previous and next
   buttons either side of a thin bar (markup: snippets/cf-set-scroll.liquid, look: theme.css,
   "THE ROW'S SCROLL BAR"). The CUBE Set builder (sections/set-product.liquid) has one under its
   three to six slots; a curated Set (snippets/pdp-gallery, on the product section) under its cities, where four
   or more run past the gallery column. Three fit both, and then the bar stays hidden.

   Shown while the row has more than fits, its thumb as wide as the share of the row in view and as
   far along as the row is scrolled, the buttons disabled at either end. Read off the row itself
   whenever it scrolls or changes size, the window resizes, or a page says its row changed
   (window.cfSetScroll.paint() - the builder, after adding or removing a city). The bar is measured
   after it is shown: hidden, it has no width.

   A button moves the row one card: a card and the gap after it, so the row's snapping lands on a
   card's edge. The thumb drags - the row follows without snapping until it is let go - and a press
   on the bar beside the thumb brings that part of the row into view. The row is the element the
   bar's track names in aria-controls. */
(() => {
  const bars = [];

  function rowOf(bar) {
    const id = bar.querySelector('[data-set-scroll-track]')?.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }

  function geometry(bar, row) {
    const track = bar.querySelector('[data-set-scroll-track]');
    if (!row || !track) return null;
    const max = row.scrollWidth - row.clientWidth;
    if (max <= 2) return null;
    const width = track.clientWidth;
    const thumb = Math.max(48, width * row.clientWidth / row.scrollWidth);
    return { max, width, thumb, room: Math.max(width - thumb, 1) };
  }

  function paintBar(bar) {
    const row = rowOf(bar);
    if (!row) return;
    bar.hidden = row.scrollWidth - row.clientWidth <= 2;
    const g = geometry(bar, row);
    if (!g) return;
    const at = Math.min(Math.max(row.scrollLeft / g.max, 0), 1);
    const thumb = bar.querySelector('[data-set-scroll-thumb]');
    thumb.style.width = `${g.thumb}px`;
    thumb.style.transform = `translateX(${at * g.room}px)`;
    bar.querySelector('[data-set-scroll-track]').setAttribute('aria-valuenow', String(Math.round(at * 100)));
    bar.querySelector('[data-set-scroll-prev]').disabled = row.scrollLeft <= 2;
    bar.querySelector('[data-set-scroll-next]').disabled = row.scrollLeft >= g.max - 2;
  }

  function bind(bar) {
    const row = rowOf(bar);
    if (!row || bar.dataset.setScrollBound) return;
    bar.dataset.setScrollBound = '1';
    bars.push(bar);

    const track = bar.querySelector('[data-set-scroll-track]');
    const thumb = bar.querySelector('[data-set-scroll-thumb]');
    const paint = () => paintBar(bar);

    const step = () => {
      const card = Array.from(row.children).find(c => !c.hidden && c.offsetWidth);
      const gap = parseFloat(getComputedStyle(row).columnGap) || 0;
      return card ? card.offsetWidth + gap : row.clientWidth * 0.8;
    };
    bar.querySelector('[data-set-scroll-prev]').addEventListener('click', () => row.scrollBy({ left: -step(), behavior: 'smooth' }));
    bar.querySelector('[data-set-scroll-next]').addEventListener('click', () => row.scrollBy({ left: step(), behavior: 'smooth' }));

    let drag = null;
    thumb.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      e.preventDefault();
      drag = { id: e.pointerId, x: e.clientX, left: row.scrollLeft };
      thumb.setPointerCapture(e.pointerId);
      bar.classList.add('is-dragging');
      row.style.scrollSnapType = 'none';
    });
    thumb.addEventListener('pointermove', (e) => {
      if (!drag || e.pointerId !== drag.id) return;
      const g = geometry(bar, row);
      if (g) row.scrollLeft = drag.left + (e.clientX - drag.x) * g.max / g.room;
    });
    const release = (e) => {
      if (!drag || e.pointerId !== drag.id) return;
      drag = null;
      bar.classList.remove('is-dragging');
      row.style.scrollSnapType = '';
    };
    thumb.addEventListener('pointerup', release);
    thumb.addEventListener('pointercancel', release);

    track.addEventListener('pointerdown', (e) => {
      if (e.target.closest('[data-set-scroll-thumb]')) return;
      const g = geometry(bar, row);
      if (!g) return;
      const x = e.clientX - track.getBoundingClientRect().left - g.thumb / 2;
      row.scrollTo({ left: Math.min(Math.max(x / g.room, 0), 1) * g.max, behavior: 'smooth' });
    });

    row.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', paint);
    if ('ResizeObserver' in window) new ResizeObserver(paint).observe(row);
    paint();
  }

  function init() {
    document.querySelectorAll('[data-set-scroll]').forEach(bind);
  }

  window.cfSetScroll = {
    // Repaint every bar, or only the one under `row`.
    paint(row) {
      init();
      bars.forEach(bar => { if (!row || rowOf(bar) === row) paintBar(bar); });
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
